module.exports = __webpack_public_path__ + "static/media/2.834a31f4.jpg";